import React from 'react';
import CancelIcon from '/src/assets/images/button/remove-hexagonal.svg?url';
import DashboardButton from './DashboardButton';

const ButtonCancel: React.FC = () => (
  <DashboardButton
    badge
    label="رد شده"
    width={80}
    height={28}
    backgroundColor="transparent"
    textColor="#DC2626"
    startIcon={
      <img
        src={CancelIcon}
        alt="loading Icon"
        style={{ width: '20px', height: '20px' }}
      />
    }
  />
);

export default ButtonCancel;
